import { yupResolver } from '@hookform/resolvers/yup'
import React from 'react'
import { useForm } from 'react-hook-form'
import Button from '../../components/Button'
import { Container, ContentCenter, Form } from '../../components/commons'
import Input from '../../components/Input'
import ImageInput from '../../components/Input/ImageInput'
import useToast from '../../hooks/useToast'
import { api } from '../../services/api'
import InputColorContent from './InputColorContent'
import { useConfigStore } from '../../store/config'
import { configSchema } from '../../validators/config.schema'
import { useUserStore } from '../../store/user'
import { updateUserSchema } from '../../validators/auth.schemas'

export interface ProfileProps {}

const Profile: React.FunctionComponent<ProfileProps> = () => {
  const { config, setConfig } = useConfigStore((state) => state)
  const { user } = useUserStore((state) => state)
  const [loading, setLoading] = React.useState<boolean>(false)

  const admin = user?.role === 'admin'
  const toast = useToast()

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<any>({
    defaultValues: admin
      ? {
          ...config,
          primaryColor: config?.primaryColor || '#646464',
          secondaryColor: config?.secondaryColor || '#424242',
        }
      : { ...user, password: '' },
    resolver: yupResolver(admin ? configSchema : updateUserSchema),
  })

  const handleSubmitLogin = async (formData: any) => {
    try {
      setLoading(true)

      if (admin) {
        const { data: response } = await api.put('/config', {
          platformName: formData.platformName,
          primaryColor: formData.primaryColor,
          secondaryColor: formData.secondaryColor,
          footerEmail: formData.footerEmail,
          footerWebsite: formData.footerWebsite,
          footerAddress: formData.footerAddress,
          footerPhone: formData.footerPhone,
        })

        let payload = response

        if (typeof formData.logo === 'object') {
          let formDataUpload: FormData = new FormData()
          formDataUpload.append('logo', formData.logo)
          try {
            const { data: responseUpload } = await api.put('/config/upload', formDataUpload)

            payload.logo = `${responseUpload.logo}?date=${new Date().getTime()}`
          } catch (error) {
            toast.errorToast('Erro ao enviar a foto perfil !')
          }
        }
        if (payload.logo) payload.logo = `${payload.logo}?date=${new Date().getTime()}`

        setConfig({ ...payload })
        if (formData.password !== '') {
          await api.put('/users/me', {
            password: formData.password,
          })
        }
      } else {
        if (formData.password === '') delete formData.password

        const { data: response } = await api.put('/users/me', {
          name: formData.name,
          password: formData.password,
        })

        let payload = response

        if (typeof formData.photo === 'object') {
          let formDataUpload: FormData = new FormData()
          formDataUpload.append('photo', formData.photo)
          try {
            const { data: responseUpload } = await api.put('/users/me/upload', formDataUpload)

            payload.photo = `${responseUpload.photo}?date=${new Date().getTime()}`
          } catch (error) {
            toast.errorToast('Erro ao enviar a foto perfil !')
          }
        }
        useUserStore.getState().setUser(payload)
      }

      toast.successToast('Perfil Atualizado com sucesso !')
    } catch (error) {
      console.log(error)
      toast.errorToast('Erro ao editar perfil !')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container style={{ maxWidth: 400, margin: 'auto' }}>
      <Form onSubmit={handleSubmit(handleSubmitLogin)}>
        <ContentCenter>
          {admin ? (
            <ImageInput borderRadius={15} error={errors?.logo} control={control} name='logo' />
          ) : (
            <ImageInput borderRadius={15} error={errors?.photo} control={control} name='photo' />
          )}
        </ContentCenter>
        {admin && <InputColorContent control={control} />}

        {admin ? (
          <>
          <Input
            label='Nome Principal da Plataforma'
            placeholder='Nome Principal da Plataforma'
            error={errors?.platformName}
            control={control}
            type='text'
            name='platformName'
          />
          <Input
            label='Email de Contato (Rodapé)'
            placeholder='Email de Contato (Rodapé)'
            error={errors?.footerEmail}
            control={control}
            type='text'
            name='footerEmail'
          />
          <Input
            label='Website (Rodapé)'
            placeholder='Website (Rodapé)'
            error={errors?.footerWebsite}
            control={control}
            type='text'
            name='footerWebsite'
          />
          <Input
            label='Endereço (Rodapé)'
            placeholder='Endereço (Rodapé)'
            error={errors?.footerAddress}
            control={control}
            type='text'
            name='footerAddress'
          />
          <Input
            label='Telefone (Rodapé)'
            placeholder='Telefone (Rodapé)'
            error={errors?.footerPhone}
            control={control}
            type='text'
            name='footerPhone'
          />
        </>
        ) : (
          <Input
            label='Nome'
            placeholder='Nome'
            error={errors?.name}
            control={control}
            type='text'
            name='name'
          />
        )}

        <Input
          placeholder='Senha'
          label='Senha'
          error={errors?.password}
          control={control}
          type='text'
          name='password'
        />

        <Button
          label='Salvar'
          loading={loading}
          type='submit'
          fullWidth
          variantType='block'
          color='primary'
        />
      </Form>
    </Container>
  )
}

export default Profile
